// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"MJ-z","smallCardRow":"NJ-z","largeCardRow":"OJ-z","productSearchRow":"PJ-z","curatedRow":"QJ-z"};